import { t } from "utils/i18n";

const validateMessages = {
  // eslint-disable-next-line no-template-curly-in-string
  required: t("PleaseEnter") + " ${label}",
};

const formValidationMessages = {
  required: t("FieldIsRequired", {
    // eslint-disable-next-line no-template-curly-in-string
    field: "${label}",
  }),
};

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
  },
};

const formItemLayoutBalance = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 12 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 12 },
  },
};

const ROW_GUTTER = {
  xs: 8,
  sm: 12,
  md: 16,
  lg: 20,
  xl: 24,
};

const TWO_COL_SPAN = {
  xs: 24,
  sm: 24,
  md: 12,
  lg: 12,
  xl: 12,
};

const FOUR_COL_SPAN = {
  xs: 24,
  lg: 6,
};

const FORM_NAME = "create-form";

export default {
  validateMessages,
  formValidationMessages,
  formItemLayout,
  formItemLayoutBalance,
  FORM_NAME,
  ROW_GUTTER,
  TWO_COL_SPAN,
  FOUR_COL_SPAN,
};
